// extracted by mini-css-extract-plugin
module.exports = {"content":"LayoutBasic__content___2BAXZ","contentMain":"LayoutBasic__contentMain___yfRQ3"};